import { ILine, IPoint } from '../models/interfaces';

export class Point implements IPoint {
    x = 0;
    y = 0;

    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }
}

export class Line implements ILine<IPoint> {
    point1: IPoint;
    point2: IPoint;
    constructor([x1, y1]: [number, number], [x2, y2]: [number, number]) {
        this.point1 = new Point(x1, y1);
        this.point2 = new Point(x2, y2);
    }
}
